import { QUERY_KEYS } from "@/common/query-keys";
import { fetchStatusLabels } from "@/lib/snipeit/lookups";
import { useQuery } from "@tanstack/react-query";

/**
 * Fetches all status labels and selects the "Bereit" label.
 */
export function useDeployableLabel() {
  return useQuery({
    queryKey: [QUERY_KEYS.statusLabels],
    queryFn: fetchStatusLabels,
    staleTime: 5 * 60_000,
    select: (labels) => {
      // First try to find "Bereit" exactly, then fall back to the first deployable
      return labels.find((label) => label.name === "Bereit") || labels.find((label) => label.type === "deployable");
    },
  });
}
